import React, { useCallback, useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Dialog, Grid } from "@material-ui/core";
import Signifier from "../../Components/Signifier";
import SortableTable from "../../Components/Table/SortableTable";
import AtsApiTableCell from "../../Components/Table/AtsApiTableCell";
import InboundAPIModal from "../../Components/Modal/InboundModals/InboundAPIModal";
import { getApis } from "../../Services/API/AtsApi";
import axios from "axios";

function APIPage(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "60%",
      marginBottom: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
      [theme.breakpoints.down("sm")]: {
        position: "unset",
      },
    },
  }));

  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [showError, setShowError] = useState(false);
  axios.defaults.headers.common["client"] = props?.clientID;

  const columns = [
    { label: "Name", propName: "name" },
    { label: "Type", propName: "assemblyName" },
    { label: "Filename", propName: "feedFileName" },
  ];

  const loadApis = useCallback(() => {
    if (props.clientID === null || props.clientID === "" || props.clientID === undefined) return;
    setLoading(true);
    setError(false);
    return getApis(props.clientID)
      .then((response) => {
        setData(response);
      })
      .catch((err) => {
        console.error("Failed to load APIs:", err);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, [props.clientID]);

  useEffect(() => {
    loadApis();
  }, [loadApis]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="API Created"
        error={showError}
      />
      <div className={classes.root}>
        {props.clientID !== null && props.clientID !== "" && props.clientID !== undefined ? (
          <>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Button
                  color="primary"
                  style={{ color: "white", marginBottom: "15px", marginLeft: "0px" }}
                  type="submit"
                  variant="contained"
                  onClick={() => setOpenModal(true)}
                >
                  Add API
                </Button>
              </Grid>
            </Grid>
            <SortableTable
              columns={columns}
              tableData={data}
              rowComponent={AtsApiTableCell}
              error={error}
              onRetry={loadApis}
              loading={loading}
              defaultSortIndex={0}
            />
          </>
        ) : (
          <div className={classes.hint}>
            <span>Select a client</span>
          </div>
        )}
      </div>
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <InboundAPIModal
          openModal={setOpenModal}
          setData={setData}
          setShowSignifier={setShowSignifier}
          setShowError={setShowError}
          clientID={props.clientID}
        />
      </Dialog>
    </>
  );
}

export default APIPage;
